var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenToSquareBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3125 2.5625C25.0625 0.8125 27.875 0.8125 29.625 2.5625L30.4375 3.375C32.1875 5.125 32.1875 7.9375 30.4375 9.6875L18.0625 22.0625C17.5625 22.5625 16.875 23 16.125 23.1875L9.875 25C9.375 25.125 8.8125 25 8.4375 24.5625C8 24.1875 7.875 23.625 8 23.125L9.8125 16.875C10 16.125 10.4375 15.4375 10.9375 14.9375L23.3125 2.5625ZM27.5 4.6875C26.9375 4.125 26 4.125 25.4375 4.6875L23.5625 6.5L26.5 9.4375L28.3125 7.5625C28.875 7 28.875 6.0625 28.3125 5.5L27.5 4.6875ZM12.6875 17.6875L11.625 21.375L15.3125 20.3125C15.5625 20.25 15.75 20.125 15.9375 19.9375L24.375 11.5L21.5 8.625L13.0625 17.0625C12.875 17.25 12.75 17.4375 12.6875 17.6875ZM12.5 5C13.3125 5 14 5.6875 14 6.5C14 7.375 13.3125 8 12.5 8H5.5C4.0625 8 3 9.125 3 10.5V27.5C3 28.9375 4.0625 30 5.5 30H22.5C23.875 30 25 28.9375 25 27.5V20.5C25 19.6875 25.625 19 26.5 19C27.3125 19 28 19.6875 28 20.5V27.5C28 30.5625 25.5 33 22.5 33H5.5C2.4375 33 0 30.5625 0 27.5V10.5C0 7.5 2.4375 5 5.5 5H12.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenToSquareBlack);
export default __webpack_public_path__ + "static/media/pen-to-square-black.916ec4d441034b8e6e35a0a47c3369f2.svg";
export { ForwardRef as ReactComponent };